var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"breadcrumb__item"},'component',_vm.binding,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value.title || _vm.$tc('loading') + '...'))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }